import { readTourCruisePickup } from '../tourCruisePickup';

const validateTourPickup = (toursToBook, tourHotelPickup) => {
  const invalidSegments = {};

  (toursToBook || []).forEach((tourItinerary) => {
    const segmentId = tourItinerary.tripSegmentId;
    const cruise = readTourCruisePickup((tourHotelPickup || {})[segmentId]);
    if (!cruise) {
      return;
    }

    const errors = {};
    if (!cruise.lineName) {
      errors.lineName = 'Please select a cruise line';
    }
    if (!cruise.shipName) {
      errors.shipName = 'Please select a ship';
    }
    if (!cruise.arrival) {
      errors.arrival = 'Please provide the arrival time';
    }
    if (!cruise.departure) {
      errors.departure = 'Please provide the departure time';
    }
    if (cruise.arrival && cruise.departure && cruise.arrival >= cruise.departure) {
      errors.departure = 'Departure must be later than arrival';
    }

    if (Object.keys(errors).length > 0) {
      invalidSegments[segmentId] = errors;
    }
  });

  return invalidSegments;
};

export default validateTourPickup;
